<template>
  <div class="container joint-container">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/joint/list' }">联报管理</el-breadcrumb-item>
        <el-breadcrumb-item>联报创建</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="status">
            <span class="label">状态：</span>
            <el-switch v-model="dataForm.status"
                       :active-value="1"
                       :inactive-value="0"></el-switch>
          </div>
        </div>
        <div class="right">
          <el-button plain
                     @click="handleClose">取消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">联报创建</h3>
      <div class="content">
        <el-form class="dataForm"
                 :model="dataForm"
                 :rules="rules"
                 ref="dataForm"
                 label-width="150px">
          <el-form-item label="联报名称"
                        prop="name">
            <el-input v-model="dataForm.name"
                      placeholder="请输入联报标题"></el-input>
          </el-form-item>
          <el-form-item label="联报描述"
                        prop="description">
            <el-input v-model="dataForm.description"
                      placeholder="请输入联报描述"></el-input>
          </el-form-item>
          <el-form-item label="最高联报科目数量"
                        prop="max_count">
            <el-input-number v-model="dataForm.max_count"
                             :min="2"
                             :max="10"
                             label="输入最高联报科目数量"></el-input-number>
          </el-form-item>
          <el-form-item label="设置商品"
                        prop="product_id">
            <el-button type="text"
                       v-if="!master_Product"
                       @click="opengoodsChooseDialog('master',0)">选择商品</el-button>
            <div class="product_all_div">
              <div class="pruduct_all_item"
                   v-if="master_Product">
                <div><span>商品名称：{{master_Product.name}}</span></div>
                <div class="pruduct_all_properties"
                     v-for="(pitem,pindex) in master_Product.properties"
                     :key="pindex"><span>规格（{{pitem.name}}）：{{pitem.values.map((v)=>{ return v.name }).join(',')}}</span></div>
                <div class="pruduct_all_remove">
                  <img src="@/assets/img/cancel_icon.png"
                       alt=""
                       srcset=""
                       @click="handleRemoveMasterItem">
                </div>
              </div>
              <el-table v-if="master_Product&&master_Product.skus.length"
                        :data="master_Product.skus"
                        size="mini"
                        style="width: 100%;margin-top:16px;">
                <el-table-column label="规格"
                                 prop="id"
                                 class="skus_table"
                                 show-overflow-tooltip
                                 min-width="200">
                  <template slot-scope="scope">
                    <span class="skus_table_span">{{scope.row.properties.map((v)=>{ return v.val }).join(',')}} 原价：{{scope.row.price}}元</span>
                  </template>
                </el-table-column>
                <el-table-column v-for="(item,index) in (dataForm.max_count-1)"
                                 :key="index"
                                 :label="count_string_arr[index]+'科联报优惠价'"
                                 prop="id"
                                 class="skus_table"
                                 align="center"
                                 width="120">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.joint_array[index]"
                              clearable
                              @input="setArrayData()">
                    </el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="搭配商品"
                        prop="product_id">
            <el-button type="text"
                       @click="opengoodsChooseDialog('normal',1)"
                       v-if="!(product_all.length >= dataForm.max_count - 1)">选择商品</el-button>
            <div class="product_all_div"
                 v-for="(item,index) in product_all"
                 :key="index">
              <div class="pruduct_all_item">
                <div><span>商品名称：{{item.name}}</span></div>
                <div class="pruduct_all_properties"
                     v-for="(pitem,pindex) in item.properties"
                     :key="pindex"><span>规格（{{pitem.name}}）：{{pitem.values.map((v)=>{ return v.name }).join(',')}}</span></div>
                <div class="pruduct_all_remove">
                  <img src="@/assets/img/cancel_icon.png"
                       alt=""
                       srcset=""
                       @click="handleRemove(index)">
                </div>
              </div>
              <el-table v-if="item.skus.length"
                        :data="item.skus"
                        size="mini"
                        style="width: 100%;margin-top:16px;">
                <el-table-column label="规格"
                                 prop="id"
                                 class="skus_table"
                                 show-overflow-tooltip
                                 min-width="200">
                  <template slot-scope="scope">
                    <span class="skus_table_span">{{scope.row.properties.map((v)=>{ return v.val }).join(',')}} 原价：{{scope.row.price}}元</span>
                  </template>
                </el-table-column>
                <el-table-column v-for="(item,index) in (dataForm.max_count-1)"
                                 :key="index"
                                 :label="count_string_arr[index]+'科联报优惠价'"
                                 prop="id"
                                 class="skus_table"
                                 align="center"
                                 width="120">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.joint_array[index]"
                              clearable
                              @input="setArrayData()">
                    </el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="有效期"
                        prop="time">
            <el-date-picker v-model="dataForm.time"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="排序值"
                        prop="sort">
            <el-input v-model="dataForm.sort"
                      placeholder="请输入排序值，纯数字"
                      style="width: 400px"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <GoodsTabsChooseJoint :visible="goodsChooseDialog"
                          type="single"
                          @close="goodsChooseDialog = false"
                          @submit="saveGoods"
                          :isAll="isAll" />
  </div>
</template>

<script>
import GoodsTabsChooseJoint from '@/components/dialog/product/GoodsTabsChooseJoint'
import { productOne } from '@/api/product'
import { createJoint } from '@/api/operation'
export default {
  components: {
    GoodsTabsChooseJoint,
  },
  data() {
    return {
      dataForm: {
        max_count: 2,
        status: 1,
      },
      product: null,
      properties: [],
      goodsChooseDialog: false,
      rules: {
        name: [{ required: true, message: '请输入拼团名称', trigger: 'blur' }],
        time: [{ required: true, message: '请输入有效期', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序值', trigger: 'blur' }],
        joint: [{ required: true, message: '请输入排序值', trigger: 'blur' }],
      },
      product_all: [],
      count_string_arr: ['二', '三', '四', '五', '六', '七', '八', '九', '十'],
      time: '',
      watchArray: [],
      master_Product: null,
      product_type: 'normal',
      isAll: 1, // 1为附属商品可选择全部商品，0为主商品选择，需要过滤掉已参加过活动的商品
    }
  },
  methods: {
    // 商品详情查询
    fetchProductInfo() {
      productOne({ id: this.product.id }).then((res) => {
        if (res) {
          if (res.skus.length) {
            res.skus.forEach((item) => {
              this.dataForm.max_count
              this.$set(item, 'joint_array', [])
            })
          } else {
            let arr = [
              {
                id: null,
                properties: [{ val: '无规格' }],
                joint_array: [],
                price: res.price,
              },
            ]
            res.skus = arr
          }
          if (this.product_type == 'normal') {
            this.product_all.push(res)
          } else {
            this.master_Product = res
            this.$set(this.master_Product, 'master_product_id', res.id)
          }
        }
      })
    },
    saveGoods(product) {
      if (product) {
        this.product = product
        // 商品详情查询
        this.fetchProductInfo()
      }
    },
    handleClose() {
      this.$router.go(-1)
    },
    handleRemove(index) {
      this.product_all.splice(index, 1)
    },
    handleRemoveMasterItem() {
      this.product_type = 'normal'
      this.master_Product = null
    },
    handleSubmit() {
      if (this.product_all.length + 1 != this.dataForm.max_count) {
        this.$message.error('请选择正确的商品个数')
        return false
      }
      let num = 0
      for (let i = 0; i < this.product_all.length; i++) {
        num += this.product_all[i].skus.length * (this.dataForm.max_count - 1)
      }
      num += this.master_Product.skus.length * (this.dataForm.max_count - 1)
      if (num !== this.watchArray.length) {
        this.$message.error('请填写联报优惠价')
        return false
      }
      if (
        this.watchArray.findIndex((v) => {
          return v.price == ''
        }) >= 0
      ) {
        this.$message.error('请填写联报优惠价')
        return
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          // 时间区间处理
          if (this.dataForm.time) {
            this.dataForm.start_time = this.dataForm.time[0]
            this.dataForm.end_time = this.dataForm.time[1] + 86399000
          } else {
            this.dataForm.start_time = ''
            this.dataForm.end_time = ''
          }
          this.dataForm.product_ids = this.product_all.map((v) => {
            return v.id
          })
          this.dataForm.product_ids.push(this.master_Product.id)
          this.dataForm.product_ids = this.dataForm.product_ids.join(',')
          this.dataForm.master_product_id = this.master_Product.id
          this.dataForm.prices = this.watchArray
          createJoint(this.dataForm)
            .then((res) => {
              this.$message.success(`创建成功`)
              this.$refs['dataForm'].resetFields()

              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    opengoodsChooseDialog(type = 'normal', isAll = 1) {
      this.isAll = isAll
      this.product_type = type
      this.goodsChooseDialog = true
    },
    formateSubmitData() {
      let a = []
      this.master_Product.skus.forEach((item) => {
        a.push(
          item.joint_array.map((v, i) => {
            return {
              product_id: this.master_Product.id,
              sku_id: item.id,
              joint_count: i + 2,
              price: v || 0,
            }
          })
        )
      })
      this.product_all.forEach((item) => {
        if (item.skus.length) {
          item.skus.forEach((skusitem, skusindex) => {
            a.push(
              skusitem.joint_array.map((v, i) => {
                return {
                  product_id: item.id,
                  sku_id: skusitem.id,
                  joint_count: i + 2,
                  price: v || 0,
                }
              })
            )
          })
        } else {
        }
      })
      if (a.length) {
        let u = []
        a.forEach((item, index) => {
          u.push(...a[index])
        })
        return u
      }
    },
    setArrayData() {
      this.watchArray = this.formateSubmitData()
    },
  },
}
</script>

<style lang="less" scoped>
.joint-container {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow-y: visible;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    margin-top: 20px;
    overflow-y: visible;

    .dataForm {
      min-width: 700px;
      width: 100%;

      .input-radio {
        display: flex;
        align-items: center;
        height: 32px;

        & + .input-radio {
          margin-top: 10px;
        }

        .text {
          width: 60px;
        }
      }
      .space {
        margin: 0 10px;
      }

      /deep/ .el-radio__label {
        display: flex;
        align-items: center;
      }
      .form-item-wrap {
        display: flex;

        /deep/ .el-input {
          width: 300px;
        }
      }
    }
  }
  .product-info {
    display: flex;

    img {
      width: 60px;
      height: 60px;
      object-fit: cover;
    }
    .text-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      overflow: hidden;
      margin-left: 5px;
    }
    .name {
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
  }
  .product_all_div {
    .pruduct_all_item {
      background: #f5f5f5;
      height: 45px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      position: relative;
      margin-top: 16px;
      .pruduct_all_properties {
        margin: 0 16px;
        font-size: 14px;
      }
      .pruduct_all_remove {
        position: absolute;
        top: 10px;
        right: 16px;
        width: 16px;
        height: 16px;
        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
      span {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        opacity: 1;
      }
    }
    .skus_table {
      .skus_table_span {
        font-size: 10px;
        border: solid;
      }
    }
  }
}
</style>